(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["somera-interactive-layers"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('somera-layers')){
customElements.define('somera-layers',class extends HTMLElement{
connectedCallback(){
this.abort?.abort();this.abort=new AbortController();const options={signal:this.abort.signal};
this.rows=Array.from(this.querySelectorAll('.sl-detail'));this.pins=Array.from(this.querySelectorAll('.sl-pin'));
this.rows.forEach((row,i)=>{row.querySelector('summary').addEventListener('click',event=>{event.preventDefault();this.activate(row.open?-1:i)},options)});
this.pins.forEach(pin=>pin.addEventListener('click',()=>this.activate(Number(pin.dataset.pin)),options));
this.addEventListener('shopify:block:select',event=>{const i=this.rows.findIndex(row=>row.dataset.block===event.detail?.blockId);if(i>=0)this.activate(i)},options);
this.activate(0);
}
activate(index){this.rows.forEach((row,i)=>{row.open=i===index});this.pins.forEach((pin,i)=>pin.setAttribute('aria-expanded',String(i===index)))}
disconnectedCallback(){this.abort?.abort()}
});}

  } catch(e) { console.error(e); }
})();
})();
